export enum BankName {
  ANZ = 'ANZ',
  ANZM = 'ANZM',
  Macquarie = 'Macquarie'
}
